export default __webpack_public_path__ + "static/media/lightning-bolt.be98129b.svg";